<template>
  <v-row justify="center" align="center" v-if="onboarding">
    <v-col lg="12" sm="12" cols="12">
      <v-card outlined>
        <v-card-title> {{ $t("analytics.users.steps.step1") }} </v-card-title>
        <v-card-text>
          <StartStep />
        </v-card-text>
      </v-card>
    </v-col>

    <v-col lg="12" sm="12" cols="12">
      <v-card outlined>
        <v-card-text>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="yellow"></v-tabs-slider>

            <v-tab
              v-for="(item, index) in tabs_elements"
              :key="index"
              :disabled="$store.state.admin.storeId == '33' && index == 1"
            >
              {{ item.text }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat height="100%" id="stepsGraph">
                <v-card-text>
                  <v-row dense justify="center" align="center">
                    <v-col lg="6" sm="6" cols="12">
                      <v-card outlined height="100%">
                        <!-- qestions step 2 -->
                        <v-card-text>
                          <span class="subheading">{{
                            $t("analytics.users.steps.step2")
                          }}</span>
                          <v-chip-group
                            column
                            v-model="steps_model.step1"
                            @change="set_default('step1')"
                          >
                            <v-chip
                              filter
                              outlined
                              @click="set_key('key1', 'questions')"
                            >
                              <span
                                v-html="
                                  store_config.i18n[this.$i18n.locale].popup
                                    .proposition4
                                "
                              ></span>
                            </v-chip>
                          </v-chip-group>
                        </v-card-text>

                        <!-- qestions step 3 -->
                        <v-card-text
                          v-if="
                            steps_model.step1 !== undefined &&
                            Step3Elements[steps_keys.key1] &&
                            Step3Elements[steps_keys.key1].length
                          "
                        >
                          <span class="subheading">{{
                            $t("analytics.users.steps.step3")
                          }}</span>
                          <v-chip-group
                            column
                            v-model="steps_model.step2"
                            @change="set_default('step2')"
                          >
                            <v-chip
                              filter
                              outlined
                              v-for="(item, index) in Step3Elements[
                                steps_keys.key1
                              ]"
                              :key="index"
                              @click="set_key('key2', item.text)"
                            >
                              <span
                                v-html="
                                  store_config.i18n[$i18n.locale].buttons[
                                    item.text
                                  ] || item.text
                                "
                              ></span>
                            </v-chip>
                          </v-chip-group>
                        </v-card-text>

                        <!-- qestions step 4 -->
                        <v-card-text
                          v-if="
                            steps_model.step2 !== undefined &&
                            Step4Elements[steps_keys.key2] &&
                            Step4Elements[steps_keys.key2].length
                          "
                        >
                          <span class="subheading">{{
                            $t("analytics.users.steps.step4")
                          }}</span>
                          <v-chip-group
                            column
                            v-model="steps_model.step3"
                            @change="set_default('step3')"
                          >
                            <v-chip
                              filter
                              outlined
                              v-for="(item, index) in Step4Elements[
                                steps_keys.key2
                              ]"
                              :key="index"
                              @click="set_key('key3', item)"
                            >
                              <span
                                v-html="
                                  store_config.i18n[$i18n.locale].buttons[
                                    item
                                  ] || item
                                "
                              ></span>
                            </v-chip>
                          </v-chip-group>
                        </v-card-text>

                        <!-- qestions step 5 -->
                        <v-card-text
                          v-if="
                            steps_model.step3 !== undefined &&
                            Step5Elements[steps_keys.key3] &&
                            Step5Elements[steps_keys.key3].length
                          "
                        >
                          <span class="subheading">{{
                            $t("analytics.users.steps.step5")
                          }}</span>
                          <v-chip-group
                            column
                            v-model="steps_model.step4"
                            @change="set_default('step4')"
                          >
                            <v-chip
                              filter
                              outlined
                              v-for="(item, index) in Step5Elements[
                                steps_keys.key3
                              ]"
                              :key="index"
                              @click="set_key('key4', item)"
                            >
                              <span
                                v-html="
                                  store_config.i18n[$i18n.locale].buttons[
                                    item
                                  ] || item
                                "
                              ></span>
                            </v-chip>
                          </v-chip-group>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            outlined
                            :disabled="steps_model.step1 === undefined"
                            @click="done"
                          >
                            select
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                    <v-col lg="6" sm="6" cols="12">
                      <v-card flat>
                        <v-card-text v-if="selectedStep">
                          <StepGraph :stepSelected="selectedStep" />
                        </v-card-text>
                        <v-card-text v-else> </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import StartStep from "./StartStep";
import StepGraph from "./StepGraph.vue";

export default {
  name: "LE_view_steps",
  components: {
    StartStep,
    StepGraph,
  },
  data() {
    return {
      tab: null,
      elements1: [
        { text: "post_command", value: "order" },
        {
          text: "informations_before_command",
          value: "informations_before_command",
        },
        { text: "the_box_by_exception", value: "the_box_by_exception" },
      ],
      elements2: ["A male", "A female"],
      Step3Elements: {
        questions: [
          { text: "post_command", value: "order" },
          {
            text: "informations_before_command",
            value: "informations_before_command",
          },
          { text: "the_box_by_exception", value: "the_box_by_exception" },
        ],
      },
      Step4Elements: {
        post_command: ["follow", "return"],
        informations_before_command: [
          "delivery",
          "return_reimbursement",
          "payment",
          "loyalty_program",
          "gift_card",
        ],
      },
      Step5Elements: {
        delivery: ["carrier"],
      },

      steps_keys: {
        key1: undefined,
        key2: undefined,
        key3: undefined,
        key4: undefined,
      },
      steps_model: {
        step1: undefined,
        step2: undefined,
        step3: undefined,
        step4: undefined,
      },

      selectedStep: undefined,
    };
  },
  computed: {
    onboarding() {
      const data = this.$store.state.analytics.onboarding;
      return data;
    },
    store_config() {
      const data = this.$store.state.store_config.store;
      return data;
    },
    tabs_elements() {
      const data = [
        {
          text: this.store_config.i18n[this.$i18n.locale].popup.proposition4,
          value: "questions",
        },
        {
          text: this.store_config.i18n[this.$i18n.locale].popup.proposition5,
          value: "first_reco",
        },
      ];
      return data;
    },
  },
  methods: {
    scrollToElement(id) {
      this.$vuetify.goTo(id, {
        duration: 1300,
        offset: 100,
        easing: "easeInOutCubic",
      });
    },
    set_default(step) {
      if (step === "step1") {
        this.steps_model.step2 = undefined;
        this.steps_model.step3 = undefined;
        this.steps_model.step4 = undefined;
        this.steps_keys.key2 = undefined;
        this.steps_keys.key3 = undefined;
        this.steps_keys.key4 = undefined;
      } else if (step === "step2") {
        this.steps_model.step3 = undefined;
        this.steps_model.step4 = undefined;
        this.steps_keys.key3 = undefined;
        this.steps_keys.key4 = undefined;
      } else if (step === "step3") {
        this.steps_model.step4 = undefined;
        this.steps_keys.key4 = undefined;
      }
      this.selectedStep = undefined;
    },
    set_key(key, value) {
      if (this.steps_keys[key] === value) {
        this.steps_keys[key] = undefined;
      } else {
        this.steps_keys[key] = value;
      }
    },
    done() {
      const arr = Object.values(this.steps_keys).filter((n) => n);
      this.selectedStep = arr[arr.length - 1];
      this.scrollToElement("#stepsGraph");
    },
  },
};
</script>
